import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SessionStateService } from '../user/session-state.service';
import { UserService } from '../user/user.service';

/**
 * Service for storing the state of the chart filters on the Controlled Medication Summary page.
 */
@Injectable()
export class ChartFilterService {
    private includeGabapentin: boolean = false;
    public gabapentinSubject: Subject<boolean>;

    private morphineChartFilter = 'Both';
    private multipleControlledMedsChartFilter = 'Both';
    private opioidsBenzodiazepinesChartFilter = 'Both';

    /** Construct */
    constructor(private sessionState: SessionStateService) {
        this.gabapentinSubject = new Subject<boolean>();
        this.setInitGabapentinState();
    }
    // *******************
    // Gabapentin filter
    // *******************
    public getGabapentinFilter(): boolean {
        return this.includeGabapentin;
    }

    public updateGabapentinFilter(filter: boolean): void {
        if (this.includeGabapentin !== filter) {
            // Only fire if the value has really changed
            this.includeGabapentin = filter;
            this.gabapentinSubject.next(this.includeGabapentin);
        }
    }

    // *******************
    // Morphine equivalent
    // *******************
    public getMorphineFilter(): string {
        return this.morphineChartFilter;
    }

    public updateMorphineFilter(filter: string) {
        this.morphineChartFilter = filter;
    }

    // *******************
    // Multiple controlled meds
    // *******************
    public getMultipleControlledMedsFilter(): string {
        return this.multipleControlledMedsChartFilter;
    }

    public updateMultipleControlledMedsFilter(filter: string) {
        this.multipleControlledMedsChartFilter = filter;
    }

    // *******************
    // Opioids and benzodiazepines
    // *******************
    public getOpioidsBenzodiazepinesFilter(): string {
        return this.opioidsBenzodiazepinesChartFilter;
    }

    public updateOpioidsBenzodiazepinesFilter(filter: string) {
        this.opioidsBenzodiazepinesChartFilter = filter;
    }

    // ******************************************
    // Sets initial state for Gabapentin checkbox 
    // ******************************************
    public setInitGabapentinState(): void {
        let incGabCb = this.sessionState.load(UserService.GABAPENTIN_STATE_KEY);

        if(incGabCb != null){
          this.includeGabapentin = incGabCb;
        }else{
          this.includeGabapentin = false;
        }
    }

    public setDefaultFilterStateBoth() {
        this.updateMorphineFilter('Both');
        this.updateMultipleControlledMedsFilter('Both');
        this.updateOpioidsBenzodiazepinesFilter('Both');
    }

}
